/*! Review grid (sections/review-grid.liquid): one-card-per-view slider below 750px (translateX, arrows, progress bar). */
(function () {
  'use strict';
  if (customElements.get('review-grid-slider')) return;
  class ReviewGridSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-review-grid-track]');
      this.prev = this.querySelector('[data-review-grid-prev]');
      this.next = this.querySelector('[data-review-grid-next]');
      this.fill = this.querySelector('[data-review-grid-progress]');
      this.index = 0;
      this.mq = window.matchMedia('(max-width: 749px)');
      this.onChange = () => this.update();
      this.mq.addEventListener('change', this.onChange);
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.update();
    }
    disconnectedCallback() { this.mq.removeEventListener('change', this.onChange); }
    get count() { return this.track ? this.track.children.length : 0; }
    go(dir) { this.index = (this.index + dir + this.count) % this.count; this.update(); }
    update() {
      if (!this.track) return;
      if (this.mq.matches) {
        this.track.style.transform = 'translateX(calc(' + (-this.index) + ' * (100% + 16px)))';
      } else {
        this.track.style.transform = '';
      }
      if (this.fill && this.count) this.fill.style.transform = 'scaleX(' + ((this.index + 1) / this.count) + ')';
    }
  }
  customElements.define('review-grid-slider', ReviewGridSlider);
})();
